<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('notes')">Notizen</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('clients.edit', note.client_id)">
        {{ form.client_name }}
      </inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.id }}
    </h1>
    <trashed-message v-if="note.deleted_at" class="mb-6" @restore="restore">
      Diese Notiz wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input v-model="form.content" :error="form.errors.content" class="pr-6 pb-8 w-full" label="Text" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!note.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <button v-if="note.deleted_at" class="text-green-600 hover:underline" tabindex="-1" type="button"
                  @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '../../Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput'

export default {
  metaInfo() {
    return {
      title: 'Notiz',
    }
  },
  components: {
    TextareaInput,
    TrashedMessage,
    LoadingButton,
  },
  layout: Layout,
  props: {
    note: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        content: this.note.content,
        id: this.note.id,
        client_name: this.note.client_name,
        client_id: this.note.client_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('notes.update', this.note.id), {
      })
    },
    destroy() {
      if (confirm('Möchten Sie diese Notiz wirklich löschen?')) {
        this.$inertia.delete(this.route('notes.destroy', this.note.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie diese Notiz wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('notes.restore', this.note.id))
      }
    },
  },
}
</script>
